/* eslint-disable */
export function isMultiple(productList) {
  return productList.length > 1
}